export const AUTH_VISIBLE = 'AUTH_VISIBLE'
export const CLOSE_AUTH = 'CLOSE_AUTH'

export const SET_HAMBURGER_DROPDOWN_STATE = 'SET_HAMBURGER_DROPDOWN_STATE'

export const HAMBURGER_DROPDOWN_STATE_MAIN = 'HAMBURGER_DROPDOWN_STATE_MAIN'
export const HAMBURGER_DROPDOWN_STATE_GET_APP = 'HAMBURGER_DROPDOWN_STATE_GET_APP'
export const HAMBURGER_DROPDOWN_STATE_LANGUAGES = 'HAMBURGER_DROPDOWN_STATE_LANGUAGES'

export const ACTIVE_FORM_LOGIN = 'LOGIN'
export const ACTIVE_FORM_SIGNUP = 'SIGNUP'
